/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldoelformulering_Ikkan6Inputs */

const nl_enums_sociaalemotioneeldoelformulering_ikkan6 = /** @type {(inputs: Enums_Sociaalemotioneeldoelformulering_Ikkan6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik kan`)
};

/**

* @param {Enums_Sociaalemotioneeldoelformulering_Ikkan6Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldoelformulering_ikkan6 = /** @type {((inputs?: Enums_Sociaalemotioneeldoelformulering_Ikkan6Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldoelformulering_Ikkan6Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldoelformulering_ikkan6(inputs)
});
export { enums_sociaalemotioneeldoelformulering_ikkan6 as "enums.SociaalEmotioneelDoelFormulering.IkKan" }